module.exports = __webpack_public_path__ + "img/albumcover-placeholder.3644e7d7.jpg";